export const CSV_DATA_MANAGEMENT_ACTIONS = {
  GET_CSV_LOGGERS: 'GET_CSV_LOGGERS',
  GET_CSV_LOGGERS_SUCCESS: 'GET_CSV_LOGGERS_SUCCESS',
  GET_CSV_LOGGERS_ERROR: 'GET_CSV_LOGGERS_ERROR',
  GET_CSV_LOGGERS_CLEAN_STATE: 'GET_CSV_LOGGERS_CLEAN_STATE',
  DOWNLOAD_CSV_DATA: 'DOWNLOAD_CSV_DATA',
  DOWNLOAD_CSV_DATA_SUCCESS: 'DOWNLOAD_CSV_DATA_SUCCESS',
  DOWNLOAD_CSV_DATA_ERROR: 'DOWNLOAD_CSV_DATA_ERROR',
  DOWNLOAD_CSV_DATA_CLEAN_STATE: 'DOWNLOAD_CSV_DATA_CLEAN_STATE',
};
// =========================================================================
export const getCSVLoggers = () => ({
  type: CSV_DATA_MANAGEMENT_ACTIONS.GET_CSV_LOGGERS,
});
export const getCSVLoggersSuccess = (data) => ({
  type: CSV_DATA_MANAGEMENT_ACTIONS.GET_CSV_LOGGERS_SUCCESS,
  payload: data,
});
export const getCSVLoggersError = ({ message }) => ({
  type: CSV_DATA_MANAGEMENT_ACTIONS.GET_CSV_LOGGERS_ERROR,
  payload: message,
});
export const getCSVLoggersCleanState = () => ({
  type: CSV_DATA_MANAGEMENT_ACTIONS.GET_CSV_LOGGERS_CLEAN_STATE,
});
// =========================================================================
export const downloadCSVData = (params) => ({
  type: CSV_DATA_MANAGEMENT_ACTIONS.DOWNLOAD_CSV_DATA,
  payload: params,
});
export const downloadCSVDataSuccess = (data) => ({
  type: CSV_DATA_MANAGEMENT_ACTIONS.DOWNLOAD_CSV_DATA_SUCCESS,
  payload: data,
});
export const downloadCSVDataError = ({ message }) => ({
  type: CSV_DATA_MANAGEMENT_ACTIONS.DOWNLOAD_CSV_DATA_ERROR,
  payload: message,
});
export const downloadCSVDataCleanState = () => ({
  type: CSV_DATA_MANAGEMENT_ACTIONS.DOWNLOAD_CSV_DATA_CLEAN_STATE,
});
// =========================================================================
